/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Replace_AllInputs */

const en_dialog_text_to_audio_replace_all = /** @type {(inputs: Dialog_Text_To_Audio_Replace_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace all`)
};

const es_dialog_text_to_audio_replace_all = /** @type {(inputs: Dialog_Text_To_Audio_Replace_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar todo`)
};

/**
* | output |
* | --- |
* | "Replace all" |
*
* @param {Dialog_Text_To_Audio_Replace_AllInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_replace_all = /** @type {((inputs?: Dialog_Text_To_Audio_Replace_AllInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Replace_AllInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_replace_all(inputs)
	return en_dialog_text_to_audio_replace_all(inputs)
});